<div class="modal-header">
    <div class="modal-title">{{fieldName}} Forecasting</div>
    <button  id="revenue-forecasting-close-btn" type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <p class="text-center">
        Your forecasted {{fieldName}} for FYE <strong>{{year}}</strong>, shows a
        <strong>
            <!-- {{percentString}}% -->
            <span *ngIf="percentString > 999">>999%</span>
            <span *ngIf="percentString <= 999">{{percentString < -999 ? '<-999' : percentString}}%</span>
        </strong>
        {{percent > 0 ? 'increase' : 'decrease'}} over the prior year.<br />
        This could suggest improper sales forecasting. (i.e. if the company’s sales are seasonal, annualizing the
        interim financials might not be accurate)<br />
        Please double check the company’s actual FYE <strong>{{year}}</strong> {{fieldName}} forecast.
    </p>
</div>

<div class="modal-footer justify-content-between">
  <label class="checkbox large m-0">
    <input class="checkbox__input" type='checkbox' id="skipInterim"
           [(ngModel)]="skipInterimWarning"
           name="skipInterim" #skipInterim="ngModel" />
    <div class="checkbox__data">
      <div class="checkbox__indicator"></div>
      <p class="checkbox__text">
        Do not show this again for this Report.
      </p>
    </div>
  </label>

  <button type="button" id="revenue-forecasting-okay-btn" class="button secondary__button large__button" (click)="onClose()">Ok</button>
</div>
